
        import * as module0 from './controllers/checkout_controller.js'
        const modules = {
            "./controllers/checkout_controller.js": module0,
        };
        export default modules;
      